module.exports = __webpack_public_path__ + "media/images/Bullets__Blood_and_Ice-e2d9feefb76065260f3569b8799d5d1a.jpg";